import { render, staticRenderFns } from "./sidebar-sm.vue?vue&type=template&id=474dc1e5"
import script from "./sidebar-sm.vue?vue&type=script&lang=js"
export * from "./sidebar-sm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports